import type { NewsItemInterface } from 'interfaces/news-item.interface';
import type { CategoryApiInterface } from 'interfaces/category.interface';
import type { ReviewRatingFilters } from 'modules/review/review.enum';

export interface ApiListInterface<T> {
    totalCount?: number;
    items: T[];
}

export interface NewsApiInterface {
    newsList: ApiListInterface<NewsItemInterface>;
}

export interface ShopCategoriesApiInterface {
    shopCategoryList: ApiListInterface<CategoryApiInterface>;
}

export interface FirmCategoriesApiInterface {
    firmCategoryList: ApiListInterface<CategoryApiInterface>;
}

export enum ApiSortingDirection {
    asc = 'ASC',
    desc = 'DESC'
}

export interface ApiSortingInterface {
    field: string;
    direction: ApiSortingDirection;
}

export interface ApiPaginationInterface {
    offset: number;
    limit: number;
}

export interface ApiParamsInterface {
    rating?: ReviewRatingFilters;
    sortingField?: string;
    sortingDirection?: ApiSortingDirection;
    offset?: number;
    limit?: number;
}
